




import { ArrowBack } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ApplyToCampaign = () => {
  const location = useLocation();
  const campaignId = location.state?.campaignId;
  const navigate = useNavigate();

  const [age, setAge] = useState('');
  const [taskLink, setTaskLink] = useState('');
  const [approvedBudget, setApprovedBudget] = useState('');
  const [image, setImage] = useState(null);
  const [followers, setFollowers] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);  // State to check if data is loaded
  const [influencerData, setInfluencerData] = useState({});
const [submitting, setSubmitting] = useState(false);

  const influencerID = localStorage.getItem('influencerID');

  useEffect(() => {
    // Fetch influencer data on component mount
    if (influencerID) {
      fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${influencerID}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.data) {
            setInfluencerData(data.data);  // Save the fetched data to statessss
            setFollowers(data.data.followers); 
            setIsDataLoaded(true);  // Data is loaded
          } else {
            toast.error('Failed to fetch influencer data!');
          }
        })
        .catch((error) => {
          toast.error('Error fetching influencer data!');
          console.error(error);
        });
    }
  }, [influencerID]);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]); // Store only one image
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous screen
  };

  const validateFields = () => {
    const fields = [
      { value: age, message: 'Age is required' },
      { value: taskLink, message: 'Task Link is required' },
      { value: approvedBudget, message: 'Approved Budget is required' },
      { value: image, message: 'Please upload an image' }
    ];

    for (let field of fields) {
      if (!field.value) {
        toast.error(field.message);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
  setSubmitting(true); // Start submitting
    const formData = new FormData();
    // Directly append the fetched data to formData
    formData.append('name', influencerData.fullname);  // Directly use influencerData for name
    formData.append('age', age); // Using the state for age
    formData.append('followers', influencerData.followers);  // Directly use influencerData for followers
    formData.append('email', influencerData.email);  // Directly use influencerData for email
    formData.append('campaignId', campaignId);
    formData.append('taskLink', taskLink);
    formData.append('instagramLink', influencerData.instagramURL);  // Directly use influencerData for instagram link
    formData.append('approvedBudget', approvedBudget);
    formData.append('applicantRealId', influencerID);

    if (image) {
      formData.append('image', image); // Append the uploaded imagessssdddddd
    }

    try {
      const response = await fetch('https://server-side-influencer-production.up.railway.app/influencer/apply-to-campaign', {
        method: 'PUT',
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result.message || 'Application submitted successfully!');
           setSubmitting(false); // End submitting
      } else {
        toast.error(result.error || result.message || 'Error submitting application!');
         setSubmitting(false); // End submitting
      }
    } catch (error) {
      toast.error(`Network Error: ${error.message}`);
       setSubmitting(false); // End submitting
    }
  };

  return (
    <div className="flex h-screen flex-col">
      {/* Fixed Header Section */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-10">
        <div className="flex justify-between items-center p-4">
          <button onClick={handleBackClick} className="text-black">
            <ArrowBack /> Back {/* Material-UI Back Arrow Icon sss*/}
          </button>
          <h1 className="text-1xl font-bold text-black ml-4">Apply</h1>
        </div>
      </div>

      {/* Main Content Below Header */}
      <div className="mt-20 flex justify-center items-center w-full px-4">
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="w-full max-w-xl p-8 bg-white rounded-lg shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-4">
            <h1 className="text-3xl font-semibold text-center mb-6 text-gray-800">Apply</h1>

            {/* Full Name (disabled after data fetch) */}
            <input
              type="text"
              placeholder="Full Name"
              value={influencerData.fullname || ''}
              disabled
              className="w-full p-3 border rounded-md"
            />
            {/* Followers (disabled after data fetch) */}
            <input
              type="number"
              placeholder="Followers"
              value={followers}
              disabled
              className="w-full p-3 border rounded-md"
            />
            {/* Email (disabled after data fetch) */}
            <input
              type="email"
              placeholder="Email"
              value={influencerData.email || ''}
              disabled
              className="w-full p-3 border rounded-md"
            />
            {/* Instagram Link (disabled after data fetch) */}
            <input
              type="url"
              placeholder="Instagram Link"
              value={influencerData.instagramURL || ''}
              disabled
              className="w-full p-3 border rounded-md"
            />

            <input
              type="number"
              placeholder="Age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              className="w-full p-3 border rounded-md"
            />
            <input
              type="url"
              placeholder="Task Link"
              value={taskLink}
              onChange={(e) => setTaskLink(e.target.value)}
              className="w-full p-3 border rounded-md"
            />
            <input
              type="number"
              placeholder="Approved Budget"
              value={approvedBudget}
              onChange={(e) => setApprovedBudget(e.target.value)}
              className="w-full p-3 border rounded-md"
            />
            <p>* Add an image or screenshot related to this campaign</p>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full p-3 border rounded-md"
            />
            {image && (
              <img
                src={URL.createObjectURL(image)}
                alt="Uploaded"
                className="w-16 h-16 object-cover border rounded mt-2"
              />
            )}
            {/* <button
              type="submit"
              className="w-full p-3 bg-gradient-to-br from-purple-600 to-blue-500 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
            >
              Submit Application
            </button> */}

            <button
  type="submit"
  disabled={submitting}
  className={`w-full p-3 bg-gradient-to-br from-purple-600 to-blue-500 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center transition ${
    submitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gradient-to-bl'
  } focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800`}
>
  {submitting ? 'Submitting...' : 'Submit Application'}
</button>

          </form>
        </div>
      </div>
    </div>
  );
};

export default ApplyToCampaign;
